const SAMPLING_RATE = 1 / 1000;

let loggingEnabled = false;
export const setLegacyImageUrlLoggingEnabled = (enabled: boolean) => {
  loggingEnabled = enabled;
};

export const logLegacyImageUrl = (context: string, url: string) => {
  try {
    if (loggingEnabled && Math.random() < SAMPLING_RATE) {
      // @ts-ignore
      window.LOGGER?.warn(`Legacy image URL detected in ${context}`, { url });
    }
  } catch (e) {
    // Ignore errors
  }
};
